import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faFileDownload } from "@fortawesome/pro-regular-svg-icons";
import { downloadFile } from "src/utils/fileDownloading.ts";
import { SirmetShopOrderBatchApi } from "src/api/generated/tenants/sirmet/shopOrderBatch/sirmetShopOrderBatchApi.ts";
import i18n from "i18next";

export const SirmetShopOrderBatchContextMenuComponents = ({
	allSelectedBatchIds,
}: {
	allSelectedBatchIds: number[];
}) => {
	return [
		<AsyncMenuButton
			key={"machineToolCsv"}
			icon={faFileDownload}
			label={i18n.t("machine_tool_csv")}
			disabled={allSelectedBatchIds.length === 0}
			onClick={async () => {
				const fileHandle = await SirmetShopOrderBatchApi.downloadMachineToolCsv({
					shopOrderBatchIds: allSelectedBatchIds,
				});
				downloadFile(fileHandle);
			}}
		/>,
		<AsyncMenuButton
			key={"dftFiles"}
			icon={faFileDownload}
			label={i18n.t("dft_files")}
			disabled={allSelectedBatchIds.length !== 1}
			onClick={async () => {
				const fileHandle = await SirmetShopOrderBatchApi.downloadDftFiles({
					shopOrderBatchId: allSelectedBatchIds[0]!,
				});
				downloadFile(fileHandle);
			}}
		/>,
		<AsyncMenuButton
			key={"dxfFiles"}
			icon={faFileDownload}
			label={i18n.t("dxf_files")}
			disabled={allSelectedBatchIds.length !== 1}
			onClick={async () => {
				const fileHandle = await SirmetShopOrderBatchApi.downloadDxfFiles({
					shopOrderBatchId: allSelectedBatchIds[0]!,
				});
				downloadFile(fileHandle);
			}}
		/>,
	];
};

